module.exports = __webpack_public_path__ + "static/img/matter.41c67f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/matter.png
// module id = +aMO
// module chunks = 44